import { getDatabase, ref, set } from "firebase/database";
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import moment from 'moment';

import app, { auth } from '../utils/firebase';

function Create() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const editNote = state?.edit;

  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [from, setFrom] = useState(editNote?.from || '');
  const [to, setTo] = useState(editNote?.to || '');
  const [content, setContent] = useState(editNote?.content || '');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      if (!u) navigate('/notes');
      setUser(u);
      setAuthLoading(false);
      if (u && !editNote) {
        setFrom(u.displayName?.split(' ')[0] || '');
      }
    });
    return unsubscribe;
  }, [navigate, editNote]);

  const send = () => {
    const db = getDatabase(app);

    if (editNote) {
      set(ref(db, `notes/${editNote.key}`), {
        from,
        to,
        content,
        uid: user.uid,
        createdAt: editNote.createdAt,
      })
        .then(() => navigate(`/notes/${editNote.key}`))
        .catch(() => alert("Não foi possível salvar. Sorry 🥺"));
    } else {
      const at = moment().format("YYYYMMDDHHmmss");
      set(ref(db, `notes/${at}`), {
        from,
        to,
        content,
        uid: user.uid,
        createdAt: Date.now(),
      })
        .then(() => navigate(`/notes/${at}`))
        .catch(() => alert("Não foi possível enviar o bilhete neste momento, tente outra vez ou volte mais tarde. Sorry 🥺"));
    }
  };

  const confirmAndSend = () => {
    if (window.confirm("Está tudo certinho com a mensagem? Posso enviar?")) send();
  };

  if (authLoading) {
    return (
      <div id="notes" className="d-flex align-items-center justify-content-center py-5 note">
        <h4 className="text-center note-text">...</h4>
      </div>
    );
  }

  return (
    <div id="notes" className="d-flex align-items-center justify-content-center py-5 note">
      <div className="container py-5 note-body text-center">
        <h2 className="note-heading">{editNote ? 'Editar' : 'Novo'}</h2>
        <input
          type="text"
          className="note-input"
          placeholder="De quem? (opcional)"
          value={from}
          onChange={(evt) => setFrom(evt.target.value)}
        />
        <input
          type="text"
          id="to"
          className="note-input"
          placeholder="Para quem? (opcional)"
          value={to}
          onChange={(evt) => setTo(evt.target.value)}
          autoFocus
        />
        <textarea
          id="new_note"
          className="note-input"
          rows={3}
          placeholder="Digite seu bilhetinho aqui..."
          value={content}
          onChange={(evt) => setContent(evt.target.value)}
        />
        <div className="note-form-actions">
          <button
            className="note-send note-send-secondary"
            type="button"
            onClick={() => navigate('/notes')}
          >
            Voltar
          </button>
          <button
            className="note-send"
            type="button"
            onClick={confirmAndSend}
            disabled={content.length < 1}
          >
            {editNote ? 'Salvar' : 'Enviar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Create;
